import { api } from './index';

export type Provider = {
  id: number;
  name: string;
  cnpj: string;
  address: string;
  phone?: string;
  email?: string;
  status?: 'ativo' | 'inativo';
  created_at?: string;
  updated_at?: string;
};

const baseUrl = '/provider';

export const providerService = {
  async getAll(): Promise<Provider[]> {
      const response = await api.get(baseUrl);
    return response.data.filter((provider: Provider) => provider.status !== 'inativo');
  },
  async create(data: Omit<Provider, 'id' | 'created_at' | 'updated_at'>): Promise<Provider> {
      const response = await api.post(baseUrl, data);
    return response.data;
  },
  async update(id: number, data: Partial<Omit<Provider, 'id' | 'created_at' | 'updated_at'>>): Promise<Provider> {
      const response = await api.put(`${baseUrl}/${id}`, data);
    return response.data;
  },
  async delete(id: number): Promise<void> {
      await api.delete(`${baseUrl}/${id}`);
  },
};
